import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { CmsService } from 'lib/services/cms.service';

@Injectable()
export class BlogPostResolver {
    constructor(private cmsService: CmsService) {}

    resolve: ResolveFn<any> = async (route: ActivatedRouteSnapshot) => {
        try {
            // Build the blog post URL from route params: /blog/:category/:post
            const category = route.params['category'];
            const post = route.params['post'];
            const url = `/blog/${category}/${post}`;

            const blogPost = await this.cmsService.getBlogPost(url);
            return blogPost;
        } catch (error) {
            // If resolver fails during SSR, return null to prevent errors
            // Client-side routing will retry the API call
            console.warn('BlogPostResolver failed, will retry client-side:', error);
            return null;
        }
    };
}
